import { Action, createReducer, on } from '@ngrx/store';
import * as SequenceMetadataActions from '../actions';
import { ISequenceMetadata } from '../../models/SequenceMetadata';
import { IDjangoErrors } from '../../../../shared/models/DjangoErrors';

export interface SequenceMetadataState {
  sequenceMetadata: ISequenceMetadata | null;
  loading: boolean;
  errors: IDjangoErrors | null;
}

const initialState: SequenceMetadataState = {
  sequenceMetadata: null,
  loading: false,
  errors: null,
};

export const sequenceMetadataReducer = createReducer(
  initialState,
  on(SequenceMetadataActions.SequenceMetadataUiActions.GetSequenceMetadata, (state) => ({
    ...state,
    loading: true,
    errors: null,
  })),
  on(SequenceMetadataActions.SequenceMetadataApiActions.GetSequenceMetadataSuccess, (state, { payload }) => ({
    ...state,
    sequenceMetadata: payload,
    loading: false,
    errors: null,
  })),
  on(SequenceMetadataActions.SequenceMetadataApiActions.GetSequenceMetadataFailure, (state, { errors }) => ({
    ...state,
    sequenceMetadata: null,
    loading: false,
    errors,
  })),
  // CreateSequenceMetadata handlers (were missing - caused loading state issues)
  on(SequenceMetadataActions.SequenceMetadataUiActions.CreateSequenceMetadata, (state) => ({
    ...state,
    loading: true,
    errors: null,
  })),
  on(SequenceMetadataActions.SequenceMetadataApiActions.CreateSequenceMetadataSuccess, (state) => ({
    ...state,
    loading: false,
    errors: null,
  })),
  on(SequenceMetadataActions.SequenceMetadataApiActions.CreateSequenceMetadataFailure, (state, { errors }) => ({
    ...state,
    loading: false,
    errors,
  })),
  on(SequenceMetadataActions.SequenceMetadataUiActions.PromoteToPrimary, (state) => ({
    ...state,
    loading: true,
    errors: null,
  })),
  on(SequenceMetadataActions.SequenceMetadataApiActions.PromoteToPrimarySuccess, (state) => ({
    ...state,
    loading: false,
    errors: null,
  })),
  on(SequenceMetadataActions.SequenceMetadataApiActions.PromoteToPrimaryFailure, (state, { errors }) => ({
    ...state,
    loading: false,
    errors,
  }))
);

export function SequenceMetadataReducer(state: SequenceMetadataState | undefined, action: Action) {
  return sequenceMetadataReducer(state, action);
}
